window._ = require('lodash');
window.Swal = require('sweetalert2');

try {
    require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');

let bearerToken = document.head.querySelector('meta[name="ws_auth_token"]')?.content;

let userId = document.head.querySelector('meta[name="user-id"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

import Echo from 'laravel-echo'

window.io = require('socket.io-client');

window.Echo = new Echo({
    key: process.env.MIX_WEBSOCKETS_APP_KEY,
    broadcaster: process.env.MIX_WEBSOCKETS_BROADCASTER,
    host: process.env.MIX_WEBSOCKETS_HOST,
    auth: {
        headers: {
            Authorization: `Bearer ${bearerToken}`,
            "X-CSRF-TOKEN": token?.content
        }
    }
});

if (userId?.content) {
    window.Echo.private(`user.${userId?.content}`).notification((notification) => {
        let notificationsList = $('.append-list');
        let notificationsBubble = $('.active-notification');

        notificationsBubble.removeClass('d-none');
        $('#empty-notification').remove()
        notificationsList.prepend(`
            <div data-id="${notification.id}" class="pop-notification list unread-notification">
                <a class="d-flex w-100" href="${notification.url}">
                    <div class="orange-notification">
                        <img src="${asset}/ico_computer.svg" alt="">
                    </div>
                    <div class="mini-card-notification">
                        <div class="flex-notification">
                            <div class="title-notification">${notification.title}</div>
                            <div class="time-notification">${notification.created_at}</div>
                        </div>
                        <div class="detail-notification">${notification.description}</div>
                    </div>
                </a>
            </div>
        `);
    });
}
